/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_CybersecurityInputs */

const en_footer_risks_cybersecurity = /** @type {(inputs: Footer_Risks_CybersecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cybersecurity`)
};

/**
* | output |
* | --- |
* | "Cybersecurity" |
*
* @param {Footer_Risks_CybersecurityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_cybersecurity = /** @type {((inputs?: Footer_Risks_CybersecurityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_CybersecurityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_cybersecurity(inputs)
});